export const COMMUNITY_LOGIN_SOURCE = 'host an event';
export const INVITATION_SOURCE = 'MEMBER_INVITATION';
export const EVENT_REGISTRATION = 'event registration';
export const SIGNUP_INTENT_ORGANISER = 'ORGANISER';
export const SIGNUP_INTENT_ATTENDEE = 'ATTENDEE';

export const WEAK_PASSWORD = 'weak';
export const PASSWORD_NOT_STRONG = 'notStrong';
export const STRONG_PASSWORD = 'strong';

export const passwordStrengthDetail = {
    [WEAK_PASSWORD]: {
        message: 'Password is weak',
        icon: 'warning',
        iconStyle: { fill: 'semantic.0', height: '12px', width: '12px' },
        passwordColor: 'lighting.7',
    },
    [STRONG_PASSWORD]: {
        message: 'You have selected a strong password',
        icon: 'checkmark_circle',
        iconStyle: { fill: 'semantic.2', height: '13px', width: '13px' },
        passwordColor: 'lighting.0',
    },
    [PASSWORD_NOT_STRONG]: {
        message: 'Password is not strong enough',
        icon: 'warning',
        iconStyle: { fill: 'semantic.0', height: '12px', width: '12px' },
        passwordColor: 'lighting.6',
    },
};
